import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsService } from '@fi-app/shared/fi-dialogs';
import { FiDialogsContentBase } from '@fi-app/shared/fi-dialogs/fi-dialogs-content-base';
import { cloneDeep } from '@fi-app/shared/utils';
import { FiValuesComparison } from '@fi-app/shared/utils/fi-values-comparison';

export interface IRenameWidgetDialogData {
    widgetName: string;
    widgetDescription: string;
}

@Component({
    selector: 'fi-rename-widget-dialog',
    templateUrl: './fi-rename-widget-dialog.component.html',
    styleUrls: ['./fi-rename-widget-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-rename-widget-dialog' },
    standalone: false,
})
export class FiRenameWidgetDialogComponent extends FiDialogsContentBase<
    IRenameWidgetDialogData,
    IRenameWidgetDialogData
> {
    protected widgetData: IRenameWidgetDialogData = cloneDeep(this.data);
    private fiDialogsService: FiDialogsService;
    fiValuesComparison: FiValuesComparison<IRenameWidgetDialogData>;

    public ngOnInit(): void {
        this.setServices();
        this.fiValuesComparison = new FiValuesComparison(() => this.widgetData);
    }

    private setServices() {
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }

    public getResult(): IRenameWidgetDialogData {
        return this.widgetData;
    }

    public isYesButtonDisabled(): boolean {
        return !this.widgetData.widgetName?.trim().length;
    }

    public getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.fiValuesComparison.isChanged());
    }
}
